import BlockedEpisodeBadge from './BlockedEpisodeBadge';

export default BlockedEpisodeBadge;
